/** Horizontally scrolling chip row for choosing between several sheets / lyrics of a song. */
import { matchesOwnAudience } from '../../shared/audience';
import type { SongFileDTO } from '../../shared/dto/library';
import { TrackDot } from '../audio/AudioControls';
import { useMe } from '../auth/AuthProvider';
import { cx } from '../components/ui';

export function FileChips({
  files,
  selectedId,
  onSelect,
  label,
}: {
  files: SongFileDTO[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  label: string;
}) {
  const me = useMe();
  return (
    <div className="-my-1 flex gap-2 overflow-x-auto py-1" role="radiogroup" aria-label={label} style={{ scrollbarWidth: 'none' }}>
      {files.map((f) => {
        const on = f.id === selectedId;
        const foreign = !!me && !matchesOwnAudience(f.audienceMask, me.section);
        return (
          <button
            key={f.id}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onSelect(f.id)}
            className={cx(
              'inline-flex min-h-11 shrink-0 items-center gap-2 rounded-full border px-4 text-[16px] font-medium whitespace-nowrap transition',
              on ? 'border-transparent bg-[var(--accent)] text-[var(--accent-ink)]' : 'border-[var(--line)] bg-[var(--surface)] text-[var(--ink-2)]',
              foreign && !on && 'border-dashed',
            )}
          >
            <TrackDot track={f} />
            {f.title}
          </button>
        );
      })}
    </div>
  );
}
